<template>
    <div class="flex flex-wrap w-full h-10 bg-ijs text-gray-900 lg:mt-2.5">
        <slot></slot>
    </div>
</template>
